import { api } from './api'
import { globalMessaging } from './globalMessaging'
import { logs } from './logs'
import { mapbox } from './mapbox'
import { notification } from './notification'
import { shipments } from './shipments'

// TODO: remove shipments and mapbox from this list of global middlewares (https://transfix.atlassian.net/browse/FE-61 - @bryanlin is on it)
export const globalMiddleware = [api, shipments, notification, mapbox, globalMessaging, logs]
